import $api from '@/http'

async function calculateOnlinePublic(formData) {
    return await $api.post('/osago/calculate/public/online', formData)
}

async function calculateOfflinePublic(formData) {
    return await $api.post('/osago/calculate/public/offline', formData)
}

async function downloadVypiskaPdf(id) {
    return await $api.get('/osago/calculate/pdf/' + id, {
        responseType: 'blob'
    })
}


export default {
    calculateOnlinePublic,
    calculateOfflinePublic,
    downloadVypiskaPdf
}

